import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import constants from '../../../lib/constants'
import Slider from 'rc-slider'
import 'rc-slider/assets/index.css'
import Modal from 'react-modal'
import Select from 'react-select'
import HSBar from "react-horizontal-stacked-bar-chart";


class VersionsView extends React.Component {
  static defaultProps = {
    stagingValues: {
      versions: [],
      pinnedVersions: [],
      status: null
    },
    productionValues: {
      versions: [],
      pinnedVersions: [],
      status: null
    },
    getAvailableVersions: _.noop,
    rolloutVersion: _.noop,
    rollbackVersion: _.noop,
    versionStatus: _.noop
  }

  static propTypes = {
    stagingValues: PropTypes.shape({
      versions: PropTypes.arrayOf(PropTypes.string),
      pinnedVersions: PropTypes.arrayOf(PropTypes.string),
      status: PropTypes.shape()
    }),
    productionValues: PropTypes.shape({
      versions: PropTypes.arrayOf(PropTypes.string),
      pinnedVersions: PropTypes.arrayOf(PropTypes.string),
      status: PropTypes.shape()
    }),
    getAvailableVersions: PropTypes.func,
    rolloutVersion: PropTypes.func,
    rollbackVersion: PropTypes.func,
    versionStatus: PropTypes.func,
  }

  constructor (props) {
    super(props)
    this.state = {
      deviceDeploymentState: constants.DEPLOYMENT_STATES.PRODUCTION,
      rolloutModelOpen: false,
      rollbackModelOpen: false,
      selectedVersion: null,
      rolloutSliderValue: 0,
      rollbackSliderValue: 0,
      rollbackVersion: null,
      rolloutSuccess: null,
      rollbackSuccess: null
    }
  }

  closeRolloutModal = () => {
    this.setState({ rolloutModelOpen: false, rolloutSuccess: null })
  }

  closeRollbackModal = () => {
    this.setState({ rollbackModelOpen: false, rollbackSuccess: null })
  }

  rolloutSliderOnChange = (e) => {
    this.setState({ rolloutSliderValue: e })
  }

  rollbackSliderOnChange = (e) => {
    this.setState({ rollbackSliderValue: e })
  }

  handleRollbackSelect = (e) => {
    console.log(e)
    this.setState({ rollbackVersion: e })
  }

  rollout = () => {
    this.props.rolloutVersion(this.state.selectedVersion,
                              this.state.rolloutSliderValue,
                              this.state.deviceDeploymentState, true)
    .then(() => this.setState({ rolloutSuccess: true })).catch(() => this.setState({ rolloutSuccess: false }))
  }

  rollback = () => {
    this.props.rollbackVersion(this.state.selectedVersion,
                               this.state.rollbackVersion.value,
                               this.state.deviceDeploymentState)
    .then(() => {
      this.setState({ rollbackSuccess: true })
    }).catch(() => this.setState({ rollbackSuccess: false }))
  }

  componentDidMount () {
    const { getAvailableVersions, versionStatus } = this.props
    getAvailableVersions(constants.DEPLOYMENT_STATES.STAGING)
    getAvailableVersions(constants.DEPLOYMENT_STATES.PRODUCTION)
    versionStatus(constants.DEPLOYMENT_STATES.STAGING)
    versionStatus(constants.DEPLOYMENT_STATES.PRODUCTION)
  }

  switchDeviceList = (deviceDeploymentState) => {
    this.setState({
      deviceDeploymentState
    })
  }

  render () {
    const { stagingValues, productionValues } = this.props
    const { deviceDeploymentState, rolloutModelOpen, rollbackModelOpen,
            selectedVersion, rolloutSliderValue, rollbackVersion, rolloutSuccess, rollbackSuccess } = this.state
    const values = deviceDeploymentState === constants.DEPLOYMENT_STATES.STAGING ? stagingValues : productionValues
    const tableRows = _.map(values.versions, (version) => {
      return (
        <tr scope='row'>
          <td> {version} </td>
          <td>
            <button type='button' disabled={true} className='btn btn-primary'
              onClick={() => this.setState({ rolloutModelOpen: true, selectedVersion: version })}>
              Rollout
            </button>
          </td>

          <td>
            <button type='button' className='btn btn-danger'
              onClick={() => this.setState({ rollbackModelOpen: true, selectedVersion: version })}>
              Rollback
            </button>
          </td>
        </tr>
      )
    })

    const modalStyles = {
      content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)',
        width : '500px',
        height : '500px',
      }
    }

    const rollbackProductionOptions = productionValues.versions.map(x => ({ label: x, value: x }))
    const rollbackStagingOptions = stagingValues.versions.map(x => ({ label: x, value: x }))

    var productionStatus
    if (this.props.productionValues.status) {
      productionStatus = Object.entries(this.props.productionValues.status).map(x => ({ name: x[0], value: x[1] }))
    } else {
      productionStatus = []
    }

    var stagingStatus
    if (this.props.stagingValues.status) {
      stagingStatus = Object.entries(this.props.stagingValues.status).map(x => ({ name: x[0], value: x[1] }))
    } else {
      stagingStatus = []
    }

    console.log(deviceDeploymentState)

    return (
      <div>
        <Modal
          isOpen={rolloutModelOpen}
          onRequestClose={this.closeRolloutModal}
          style={modalStyles}
          shouldCloseOnOverlayClick
        >
          <h1>Rollout</h1>
          <h2>Version {selectedVersion}</h2>
          <div>
            <div>
              <label>Percentage to deploy to {rolloutSliderValue}</label>
              <Slider
                min={0}
                max={100}
                onChange={this.rolloutSliderOnChange}
              />
            </div>
            <br />
            <div>
              <button className='btn btn-primary' onClick={this.rollout}>
                Rollout
              </button>
            </div>
            <br />
            <div>
              {rolloutSuccess === true ?
                <div className='alert alert-success' role='alert'> Success </div>
                : ''}
              {rolloutSuccess === false ?
                <div className='alert alert-failure' role='alert'> Success </div>
               : ''}
            </div>
          </div>

        </Modal>

        <Modal
          isOpen={rollbackModelOpen}
          onRequestClose={this.closeRollbackModal}
          style={modalStyles}
          shouldCloseOnOverlayClick
        >

          <h1>Rollback</h1>
          <h2>Version {selectedVersion}</h2>
          <div>
            <div>
              <label>Rollback to</label>
              { deviceDeploymentState === constants.DEPLOYMENT_STATES.PRODUCTION ?
                <Select
                  options={rollbackProductionOptions}
                  value={rollbackVersion}
                  onChange={this.handleRollbackSelect}
                />
              :
                <Select
                  options={rollbackStagingOptions}
                  value={rollbackVersion}
                  onChange={this.handleRollbackSelect}
                />
              }
            </div>
            <br/>
            <div>
              <button className='btn btn-danger' onClick={this.rollback}>
                Rollback
              </button>
            </div>
            <br />
            <div>
              {rollbackSuccess === true ?
                <div className='alert alert-success' role='alert'> Success </div>
                : ''}
              {rollbackSuccess === false ?
                <div className='alert alert-failure' role='alert'> Success </div>
               : ''}
            </div>
          </div>

        </Modal>

        <ul className='nav nav-tabs'>
          <li className='nav-item'>
            <div
              className={`nav-link ${deviceDeploymentState === constants.DEPLOYMENT_STATES.PRODUCTION ? 'active' : ''}`}
              onClick={() => this.switchDeviceList(constants.DEPLOYMENT_STATES.PRODUCTION)}>
              Production
            </div>
          </li>
          <li className='nav-item'>
            <div className={`nav-link ${deviceDeploymentState === constants.DEPLOYMENT_STATES.STAGING ? 'active' : ''}`}
              onClick={() => this.switchDeviceList(constants.DEPLOYMENT_STATES.STAGING)}>
              Staging
            </div>
          </li>
        </ul>

        { deviceDeploymentState === constants.DEPLOYMENT_STATES.PRODUCTION ?
          <HSBar
            showTextIn
            data={productionStatus} />
          :
          <HSBar
            showTextIn
            data={stagingStatus} />
        }

        <div className='table-responsive'>
          <table className='table table-striped'>
            <thead className='thead-dark'>
              <tr>
                <th scope='col'> Version Number </th>
                <th scope='col'> Rollout </th>
                <th scope='col'> Rollback </th>
              </tr>
            </thead>
            <tbody>
              {tableRows}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default VersionsView



// WEBPACK FOOTER //
// ./src/routes/Versions/components/VersionsView.js